<template>
  <div class="body">
    <div class="container">
      <router-link :to="`/admin`">
        <button type="button" class="buton btn" style="margin-bottom: 5px;">
          Înapoi
        </button>
      </router-link>

      <div v-if="leaderboardData.length > 0">
        <b-table
          :items="leaderboardData"
          :fields="fields"
          :bordered="true"
          :sticky-header="'400px'"
          :head-variant="'light'"
          :striped="true"
          :sort-by="'date'"
          :sort-desc="true"
          :no-border-collapse="true">
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'

export default {
  name: 'Leaderboard',

  data:() => ({
    leaderboardData: [],

    fields: [
      {
        key: 'name',
        sortable: true,
        label: 'Elev',
        thClass: 'text-left',
        tdClass: 'text-left',
      },

      {
        key: 'email',
        sortable: true,
        label: 'Email',
        thClass: 'text-left',
        tdClass: 'text-left',
      },

      {
        key: 'points',
        sortable: true,
        label: 'Punctaj Total'
      }
    ],
  }),

  created() {
    this.getData(this.$route.params.leaderboard)
  },

  watch: {
    '$route.params.leaderboard': function (leaderboard) {
      this.getData(leaderboard)
    }
  },

  methods: {
    ...mapActions({
      sessionExpired: 'auth/sessionExpired'
    }),

    getData() {
      if(this.$route.params.leaderboard == "all") {
        axios.get('/general-leaderboard').then(response => {
          this.leaderboardData = response.data
        }).catch((e) => {
          if(e.response.status == 401){
            this.sessionExpired()
            alert('Sesiunea a expirat. Te rugăm să te autentifici din nou.')
            this.$router.replace({ name: 'login' })
          }
        })
      } else {
        axios.get(`/leaderboard/${this.$route.params.leaderboard}`).then(response => {
          this.leaderboardData = response.data
        }).catch((e) => {
          if(e.response.status == 401){
            this.sessionExpired()
            alert('Sesiunea a expirat. Te rugăm să te autentifici din nou.')
            this.$router.replace({ name: 'login' })
          }
        })
      }
    }
  }
}
</script>

<style scoped>

.body {
 display: flex;
 align-content: center;
 justify-content: center;
 flex-direction: column;
 height: 100%;
}

.container {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 15px;
  width: 90%;
  max-width: 90%;
  position: relative;
  -webkit-box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  text-align: center;
}
</style>
